import { LogEntry } from 'constants/global'
import Storage from 'modules/storage'
import { nanoid } from 'nanoid'
import { ErrorWithContext } from 'types/global'
import { AsyncFn, Awaited } from 'types/utilities'

const regLogger = (function RegLogger(maxSize: number) {
  return {
    createLog: (id: string, options: { name: string; ctx?: Record<string, any> }) => {
      const { name, ctx } = options
      const regLog = Storage.getRegistrationLog() ?? { refs: [], logs: {} }
      regLog.refs.unshift(id)
      regLog.logs[id] = {
        operation: name,
        start: new Date().toISOString(),
        ctx: ctx ? JSON.stringify(ctx).replaceAll(',', ', ') : null,
      }
      if (regLog.refs.length > maxSize) {
        const removeId = regLog.refs.pop()
        removeId && delete regLog.logs[removeId]
      }
      Storage.saveRegistrationLog(regLog)
    },
    updateLog: (id: string, data: Partial<LogEntry>) => {
      const regLog = Storage.getRegistrationLog()
      const savedLog = regLog?.logs?.[id]
      if (!savedLog) return

      const updated = {
        ...regLog,
        logs: {
          ...regLog.logs,
          [id]: {
            ...savedLog,
            ...data,
          },
        },
      }

      Storage.saveRegistrationLog(updated)
    },
    getLogsByDate: () => {
      let orderedLogs: LogEntry[] = []
      const regLog = Storage.getRegistrationLog()
      if (!regLog) return orderedLogs

      regLog.refs.forEach(ref => regLog.logs[ref] && orderedLogs.push(regLog.logs[ref]))
      return orderedLogs
    },
  }
})(200)

export function withRegLogAsync<T extends AsyncFn>(fn: T, opName?: string) {
  return async (...args: Parameters<T>): Promise<Awaited<ReturnType<T>>> => {
    const operation = createRegLog(opName ?? fn.name)
    try {
      const res = await fn(...args)
      operation.success()
      return res
    } catch (err) {
      operation.fail(err as Error | ErrorWithContext)
      throw err
    }
  }
}

export function createRegLog(operationName: string, ctx: Record<string, any> = {}) {
  const id = nanoid(5)
  const { userStatus, tennisId } = Storage.getUser() ?? {}
  const { isWalkUpUser } = Storage.getRegistrationData() ?? {}
  const defaultCtx = {
    location: window.location.pathname,
    status: userStatus,
    tennisId,
    wu: isWalkUpUser,
  }
  regLogger.createLog(id, {
    name: operationName,
    ctx: {
      ...defaultCtx,
      ...ctx,
    },
  })

  return {
    success: () => {
      regLogger.updateLog(id, { end: new Date().toISOString(), error: null })
    },
    fail: (error: Error | ErrorWithContext) => {
      const data = { end: new Date().toISOString(), error: error.message, rayId: error['rayId'] }
      regLogger.updateLog(id, data)
    },
  }
}

export default regLogger
